<template>
    <div id="indexChartBar"></div>
</template>

<script>
 import * as echarts from "echarts";
export default {
name: 'index-bar-chart',
props: {
    collapsed: {
        type: Boolean,
    },
    yData: {
        type: Array,
        default: () => {
            return []
        }
    }
},
data () {
  return {
    xData:['（0,40）','（40,50）','（50,60）','（60,70）','（70,80）','（80,100）'],
  }
},
mounted () {
    var _this=this;
    window.addEventListener("resize", ()=>{
        if(_this.chartLine!=null){
            _this.chartLine.resize();
        }
    })
},
watch: {
    'yData': {
      handler (val) {
        this.drawLineChart();
      },
      deep: true
    },
    'collapsed': {
        handler (val) {
            if(this.chartLine!=null){
                this.chartLine.resize();
            }
        },
        deep: true
    },
},
methods: {
    drawLineChart:function() {
        if(this.yData.length==0){
            return;
        }
        this.chartLine = echarts.init(document.getElementById('indexChartBar'));
        this.chartLine.setOption({
            title: {
                text: '',
                x:'center'
                // text: '数据趋势图'
            },
            tooltip: {
                trigger: 'axis',
                formatter: function(params) {
                    var result = params[0].name+':'+ params[0].data+'次';
                    return result;
                },
            },
            grid: {
                left: '4%',
                right: '10%',
                bottom: '5%',
                top:40,
                containLabel: true
            },
            xAxis: {
                boundaryGap: true,
                name:'范围',
                data:this.xData,
                axisLabel:{interval: 0}
            },
            yAxis: {
                type: 'value',
                name:'次数'
            },
            series:[{
                showBackground: true,
                barCategoryGap: '50%',
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#83bff6' },
                    { offset: 0.5, color: '#188df0' },
                    { offset: 1, color: '#188df0' }
                    ])
                },
                emphasis: {
                    itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#2378f7' },
                        { offset: 0.7, color: '#2378f7' },
                        { offset: 1, color: '#83bff6' }
                    ])
                    }
                },
                data: this.yData,
                type: 'bar'
            }]
        },true);
    },
}
}
</script>

<style lang="scss">
#indexChartBar{
    width: 100%;
    height: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// IndexBarChart.vue?246cd28a